import * as React from 'react';
import { useSelector } from 'react-redux';
import { Layout, Sidebar } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import { darkTheme, lightTheme } from './themes';
// import { ThemeProvider } from '@material-ui/styles';
// import { makeStyles } from '@material-ui/core/styles';
import { AppState } from '../types';
 

const CustomSidebar = (props: any) => (
    <Sidebar 
        {...props} 
        size={240}
        closedSize={68}
        style={{
            overflowX: 'hidden',
            overflowY: 'visible'
        }}
    />
);

export default (props: any) => {
    const theme = useSelector((state: AppState) =>
        state.theme === 'dark' ? darkTheme : lightTheme
    );
    return (
        <Layout
          
            {...props}
            appBar={AppBar}
            sidebar={CustomSidebar}
            menu={Menu}
            theme={theme}
        />
    );
};
